import axios from 'axios';
import { API_URL } from '../config/config';
import { getHeaderOptions } from './getHeaderOptions';

export interface UserProfileData {
  _id?: string;
  firstName: string;
  lastName: string;
  countryCode: string;
  phone: string;
  email: string;
  profilePicture?: string;
}

/**
 * Fetch user profile data
 */
export const getUserProfile = async () => {
  const headers = {
    ...getHeaderOptions(),
    Authorization: localStorage.getItem('auth_token') || ''
  };
  const response = await axios.get(`${API_URL}api/v1/user/profile`, { headers });
  return response.data;
};

/**
 * Update user profile data
 */
export const updateUserProfile = async (data: Partial<UserProfileData>) => {
  const headers = {
    ...getHeaderOptions(),
    Authorization: localStorage.getItem('auth_token') || ''
  };

  // Remove _id from update payload
  const { _id, ...dataToUpdate } = data as UserProfileData;

  const response = await axios.put(`${API_URL}api/v1/user/profile`, dataToUpdate, { headers });
  return response.data;
};
